//分页参数类
//Predicates条件参数，参看Predicates类
//pageIndex页码
//pageSize 一页列表数量
//Sort asc升序，desc降序
class PagingBody{
    constructor(predicates,pageIndex,pageSize,orderBy,sort){
        this.Predicates = predicates;
        this.PageIndex = pageIndex;
        this.PageSize = pageSize;
        this.OrderBy = orderBy;
        this.Sort=sort;
    }
}
export { 
    PagingBody
}